import { motion, useScroll, useTransform } from "framer-motion";
import { UI } from "@/data/content";
import { ArrowDown } from "lucide-react";

const Masked = ({ children, delay, className }) => (
  <span className="block overflow-hidden">
    <motion.span
      className={`block ${className || ""}`}
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.1, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export default function Hero({ lang }) {
  const t = UI[lang];
  const { scrollY } = useScroll();
  const imgY = useTransform(scrollY, [0, 900], [0, 160]);
  const fade = useTransform(scrollY, [0, 600], [1, 0]);

  return (
    <section id="top" data-testid="hero" className="relative min-h-screen flex items-center overflow-hidden pt-16">
      <motion.div style={{ opacity: fade }} className="relative z-10 w-full px-6 sm:px-12 grid lg:grid-cols-[1.3fr_1fr] gap-12 items-center">
        <div>
          <Masked delay={0.1}>
            <span className="font-mono text-xs tracking-[0.25em] uppercase text-[#B03A52]">{t.presentation} · {t.heroEyebrow}</span>
          </Masked>
          <h1 className="mt-6 font-serif tracking-tight text-[#F4EFEA]">
            <Masked delay={0.25} className="text-4xl sm:text-5xl lg:text-6xl">Pia Dolesch</Masked>
            <Masked delay={0.4} className="text-4xl sm:text-5xl lg:text-6xl italic text-[#B03A52]">
              {lang === "de" ? "Bilder, die etwas bewegen" : lang === "en" ? "Images that change your viewpoint" : "Des images qui changent votre point de vue"}
            </Masked>
          </h1>
          <Masked delay={0.6}>
            <span className="mt-6 block text-base sm:text-lg leading-relaxed text-[#A89A9E] max-w-md">{t.heroTagline}</span>
          </Masked>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.2, duration: 1 }}
            className="mt-12 flex items-center gap-3 font-mono text-[11px] tracking-[0.25em] uppercase text-[#A89A9E]"
          >
            <ArrowDown size={14} className="text-[#B03A52] animate-bounce" />
            {t.scrollHint}
          </motion.div>
        </div>
        <motion.div
          style={{ y: imgY }}
          initial={{ opacity: 0, scale: 0.96 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.5, duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
          className="relative max-w-md mx-auto lg:max-w-none w-full"
        >
          <div className="absolute -inset-3 border border-[#7E2438]/40 translate-x-4 translate-y-4" />
          <img
            data-testid="hero-portrait"
            src="/images/hero-portrait.webp"
            alt="Pia Dolesch"
            className="relative w-full aspect-[3/4] object-cover"
          />
        </motion.div>
      </motion.div>
    </section>
  );
}
